import { API_URL } from "../config/config";
import { downloadRequest, getRequest, patchRequest } from "../utils/axiosUtils";
import { formatStoredPhone, getFilterQuery, getStatusLabel } from "../utils/helperFunction";
import moment from "moment";

export const fetchUniversityCounselingFormList = async ({
  setRows,
  filterData = {},
  setRowCount
}) => {
  try {
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/leads/web/counseling/getUniversityCounselingForm${query}`


    const response = await getRequest({url });

    if (response.status >= 200 && response.status < 300 && response.data) {
      const pagination = response.data?.pagination
      const options = (response.data?.data || []).map((item, idx) => ({
        sNo: (pagination?.page-1)*pagination.limit + (idx+1),
        id: item._id,
        studentDetails: item?.name || '',
        emailID: item?.email || '',
        phoneNumber:  item?.phone ? formatStoredPhone(item?.phone) : '-',
        universityName: item?.university || '',
        course: item.course || '',
        dob: item?.dob || '',
        message: item?.message || '',
        status:item?.status ? getStatusLabel(item?.status) :  "-",
        submitted:item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY") : '',
        source:item?.source || "-",
        leadSource:item?.utmData ? `${item?.utmData?.utm_campaign || "-"} | ${item?.utmData?.utm_medium || "-"} | ${item?.utmData?.utm_source || "-"}` : "-",
        assignedTo:item?.counselorId ? `${item?.counselorId?.firstName || ""} ${item?.counselorId?.lastName || ""}`.trim() :"",
        history:item?.history?.map(ele=>{
          return {
            ...ele,
            updatedBy: ele?.updatedBy ? `${ele?.updatedBy?.firstName || ""} ${ele?.updatedBy?.lastName || ""}` : "System",
            date:ele.createdAt ? moment(ele.createdAt).format("DD/MM/YYYY") : '',

          }
        }) || [],
        isRegistrationDone:item?.status==="registration_done",
      }));
      setRows(options);
      setRowCount && setRowCount(response.data?.pagination?.total || 0)
    } else {
      setRows([]);
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchUniversityCounselingFormList error",error);
    
    setRows([]);
      throw new Error(error?.response?.data?.message || `Failed to fetch details`);
  }
};

export const updateUniversityCounselingStatus = async (id, status,comment) => {
  try {
    if (!id || !status || !comment) {
      throw new Error('Counseling ID, comment and status are required')
    }
  
    const response = await patchRequest({
      url: `${API_URL}/leads/web/counseling/updateUniversityCounselingStatus`,
      data: { status,id,comment},
    })
  
    if (response?.data?.success === false) {
      throw new Error(response.data.message || 'Status update failed')
    }
  
    return response.data
    
  } catch (error) {
      throw new Error(error?.response?.data?.message || `Failed to update details`);
  }
}

export const assignCouncilorToCounselingLead = async ({setSaving,payload}) => {
  try {
    const {_id,counselorId} = payload
    if (!_id || !counselorId) {
      throw new Error('Counseling ID, counselor ID are required')
    }
  
    setSaving && setSaving(true)
    const response = await patchRequest({
      url: `${API_URL}/leads/web/counseling/assignCouncilorToCounselingLead`,
      data: { _id,counselorId},
    })
  
    if (response?.data?.success === false) {
      throw new Error(response.data.message || 'Assign counselor failed')
    }
  
    return response.data
    
  } catch (error) {
      throw new Error(error?.response?.data?.message || `Failed to assign counselor`);
  }finally{
    setSaving && setSaving(false)
  }
}

export const downloadWebLeads = async ({
  setDownloading,
  filterData={}
}) => {
  try {
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/leads/web/counseling/downloadWebLeads${query}`

    setDownloading && setDownloading(true)
    const response = await downloadRequest({ url });

    if (response.status >= 200 && response.status < 300 && response.data) {
      const blob = new Blob([response?.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "counselling-leads.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("downloadWebLeads error", error);
    throw new Error(error?.response?.data?.message || `Failed to download`);
  } finally {
    setDownloading && setDownloading(false)
  }
};

export const fetchCounselingUtmType = async (
  {
setUtmTypeList
}) => {
  let options = {}
  try {

    const url = `${API_URL}/leads/web/counseling/utmTypeList`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data?.data) {
      const data = response.data?.data
      if(typeof data==="object" && !Array.isArray(data)){
        const keys = Object.keys(data)
        keys?.forEach(key=>{
          options[key] = {
            list:["All","Generic",...data[key]],
            placeholder: `All ${key?.split("_")?.[1] || ""}`
          }
        })
      }
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAllCounselingUtm error",error);
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setUtmTypeList(options)
  }
};